var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.39998C19.6546 5.39998 21.2931 5.72588 22.8218 6.35909C24.3505 6.9923 25.7395 7.92041 26.9095 9.09043C28.0795 10.2604 29.0076 11.6495 29.6409 13.1782C30.2741 14.7069 30.6 16.3453 30.6 18C30.6 19.6546 30.2741 21.2931 29.6409 22.8218C29.0076 24.3505 28.0795 25.7395 26.9095 26.9095C25.7395 28.0795 24.3505 29.0076 22.8218 29.6409C21.2931 30.2741 19.6546 30.6 18 30.6V5.39998ZM18 3.59998C14.1809 3.59998 10.5182 5.11711 7.81764 7.81764C5.11711 10.5182 3.59998 14.1809 3.59998 18C3.59998 21.8191 5.11711 25.4818 7.81764 28.1823C10.5182 30.8828 14.1809 32.4 18 32.4C21.8191 32.4 25.4818 30.8828 28.1823 28.1823C30.8828 25.4818 32.4 21.8191 32.4 18C32.4 14.1809 30.8828 10.5182 28.1823 7.81764C25.4818 5.11711 21.8191 3.59998 18 3.59998Z",
    fill: "#F8F8F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeIconDark);
export default __webpack_public_path__ + "static/media/themeIconDark.f8c8bbb5058b6353936bb2decba4dd8c.svg";
export { ForwardRef as ReactComponent };